import { render, staticRenderFns } from "./ProductSliderItem.vue?vue&type=template&id=576ccb81&scoped=true&"
import script from "./ProductSliderItem.vue?vue&type=script&lang=js&"
export * from "./ProductSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductSliderItem.vue?vue&type=style&index=0&id=576ccb81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ccb81",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,BookOpen: require('/vercel/path0/components/icons/BookOpen.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default,ProductPrice: require('/vercel/path0/components/product/ProductPrice.vue').default,ArrowLink: require('/vercel/path0/components/general/ArrowLink.vue').default})
